import React, { useState } from 'react';

import type { Tag } from '../../../../core/data-sources/frapi/data-types.js';

import { FilterButton } from './FilterButton.js';

interface FilterCloudProps {
  activeFilters: Tag[];
  setFilter: (tag: Tag) => void;
  filters: Tag[];
  isCheckbox?: boolean;
}

const LIMIT = 10;

export const FilterCloud: React.FC<FilterCloudProps> = ({
  filters,
  activeFilters,
  setFilter,
  isCheckbox,
}) => {
  const shouldSlice = filters.length >= LIMIT;
  const [showAll, setShowAll] = useState(shouldSlice);

  return (
    <div>
      <div>
        {filters.slice(0, showAll ? LIMIT : filters.length).map((t) => (
          <FilterButton
            key={t.id}
            tag={t}
            handleClick={setFilter}
            active={activeFilters.some((f) => f.id === t.id)}
            isCheckbox={isCheckbox}
          />
        ))}
      </div>
      {shouldSlice && (
        <button
          className="show-more-filters-button"
          onClick={() => setShowAll(!showAll)}
        >{`${showAll ? '+' : '-'} Vis ${showAll ? 'alle' : 'færre'}`}</button>
      )}
    </div>
  );
};
